import type { LocaleCode } from "@/i18n/types";
import { DEFAULT_LOCALE, isLocale, LOCALES } from "@/i18n/types";

const STORAGE_KEY = "apolo-seed:locale";

function fromStorage(): LocaleCode | null {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isLocale(stored) ? stored : null;
  } catch {
    return null;
  }
}

function fromNavigator(): LocaleCode | null {
  if (typeof navigator === "undefined") return null;
  const candidates = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];
  for (const candidate of candidates) {
    const short = candidate.split("-")[0]?.toLowerCase();
    if (isLocale(short)) return short;
  }
  return null;
}

export function detectLocale(): LocaleCode {
  return fromStorage() ?? fromNavigator() ?? DEFAULT_LOCALE;
}

export function persistLocale(locale: LocaleCode): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // storage may be disabled; persistence is best-effort
  }
}

export const LOCALE_STORAGE_KEY = STORAGE_KEY;
export { LOCALES };
